import {getInteractionId, setInteractionId} from '@servicenow/ui-metrics';
import {
	COMPONENT_DISCONNECTED,
	SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED
} from '../../constants';
import {HELPERS_SCHEDULED, HELPERS_IMMEDIATE} from '../../symbols';
import {normalizeActionMeta, getHostVariables} from '../../utils';

// this is done so that we don't break anyone dispatching from a disconnect
// function or action handler; people are relying on this to unsubscribe from
// AMB and other types of clean up. the AMB effect should be changed into a
// behavior that has a COMPONENT_DISCONNECTED handler, so that people don't
// have to manually clean up or rely on this broken functionality.
export function wrapDispatch(host, action) {
	const hostVariables = getHostVariables(host);
	const interactionId = getInteractionId(action.meta);
	const helpers = action.meta[SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED]
		? hostVariables[HELPERS_IMMEDIATE]
		: hostVariables[HELPERS_SCHEDULED];
	const {
		updateState: originalUpdateState,
		updateProperties: originalUpdateProperties,
		updateContext: originalUpdateContext,
		dispatch: originalDispatch
	} = helpers;
	const updateState = (...args) => originalUpdateState(...args, interactionId);
	const updateProperties = (...args) => originalUpdateProperties(...args, interactionId);
	const updateContext = (...args) => originalUpdateContext(...args, interactionId);
	let dispatch;

	if (
		action.type !== COMPONENT_DISCONNECTED &&
		!action.meta[SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED]
	) {
		dispatch = (type, payload, meta = {}, error) => {
			// eslint-disable-next-line no-param-reassign
			meta = normalizeActionMeta(meta, {host});
			setInteractionId(meta, interactionId);
			return originalDispatch(type, payload, meta, error);
		};
	} else {
		dispatch = (type, payload, meta = {}, error) => {
			// eslint-disable-next-line no-param-reassign
			meta = normalizeActionMeta(meta, {host});
			setInteractionId(meta, interactionId);
			meta[SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED] = true; // eslint-disable-line no-param-reassign
			return originalDispatch(type, payload, meta, error);
		};
	}

	dispatch.updateState = updateState;
	dispatch.updateProperties = updateProperties;
	dispatch.updateContext = updateContext;

	return {
		updateState,
		updateProperties,
		updateContext,
		dispatch
	};
}
